import * as React from 'react'

import Rating, { formatLabel } from 'main/components/school/Rating'
import { Text, Title } from 'main/ui'
import { SchoolPage_school_aggregateRatings } from '../../gql'
import { Container } from './OverallRating.styles'

interface IProps {
  aggregateRatings: SchoolPage_school_aggregateRatings
}

export default function OverallRating(props: IProps) {
  const { aggregateRatings } = props

  return (
    <Container>
      <Rating value={aggregateRatings.overall || 0} />
      <Title kind="section">{formatLabel(aggregateRatings.overall || 0)}</Title>
      <Text muted>({aggregateRatings.count})</Text>
    </Container>
  )
}
